module.exports = __webpack_public_path__ + "img/anguilla.0c7adf19.png";